import { FC, forwardRef } from 'react';

import { StyledRadio, StyledRadioContainer } from './RadioButton.styles';
import { RadioButtonProps } from './RadioButton.types';
import useRadioButton from '@/common/components/hooks/useRadioButton/useRadioButton';

const RadioButton: FC<RadioButtonProps> = forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ id, name, value, children, isDisabled, checked, onChange: onChangeProp }, ref) => {
    const { disabled, handleChange, isRadioChecked, isValueChecked, buttonName } = useRadioButton({
      name,
      value,
      disabled: isDisabled,
      checked,
      onChange: onChangeProp,
    });

    return (
      <StyledRadioContainer htmlFor={id} disabled={disabled} checked={isRadioChecked}>
        <StyledRadio
          ref={ref}
          type="radio"
          onChange={handleChange}
          id={id}
          data-testid={id}
          name={buttonName}
          checked={isValueChecked}
          value={value}
          disabled={disabled}
          aria-checked={isValueChecked}
        />
        {children}
      </StyledRadioContainer>
    );
  },
);

RadioButton.displayName = 'RadioButton';

export default RadioButton;
